import {
  FieldErrors,
  FieldValues,
  Path,
  UseFormRegister,
} from "react-hook-form";
import { Trans, useTranslation } from "react-i18next";

import { Checkbox } from "@/components/Interface/FormFields/Checkbox/Checkbox";

interface Props<T extends FieldValues> {
  register: UseFormRegister<T>;
  errors: FieldErrors<T>;
  name: Path<T>;
}

export const TermsAgreement = <T extends FieldValues>({
  register,
  errors,
  name,
}: Props<T>) => {
  const { t } = useTranslation();

  return (
    <Checkbox<T>
      id="termsAgreement"
      name={name}
      value="yes"
      labelComponent={
        <div className="w-60 xsPlus:w-full">
          <Trans
            components={[
              <a
                target="_blank"
                aria-label="Link to terms and condition"
                key="termsAndConditionsLink"
                href={t("Footer.termsConditions.url")}
                className="inline w-fit border-b border-solid border-foreground-primary font-semibold text-foreground-primary hover:-mb-px hover:border-b-2 focus-visible:!outline focus-visible:!outline-2 focus-visible:!outline-offset-4 focus-visible:!outline-foreground-primary"
                rel="noreferrer"
              />,
            ]}
            i18nKey="Onboarding.sections.checkout.acceptTerms"
          />
        </div>
      }
      errors={errors}
      register={register}
    />
  );
};
